import React, { useState, useEffect, useRef } from 'react';
import './carousel.css';

// Import professional signup images
import hairdresserImage from '../../assets/images/professional-signup/hairdresser.png';
import nailTechImage from '../../assets/images/professional-signup/nail-tech.png';
import barberImage from '../../assets/images/professional-signup/barber.png';
import appointmentImage from '../../assets/images/professional-signup/appointment.png';

// Define slides outside component to prevent recreation on every render
// This is critical for iOS Safari which has smaller call stack limits
const SLIDES = [
  {
    title: "Zero Commissions",
    subtitle: "Keep 100% of what you earn",
    image: hairdresserImage,
    color: "#007EA0"
  },
  {
    title: "Smart Appointment System",
    subtitle: "Deposits, reminders, no-shows avoided",
    image: nailTechImage,
    color: "#2AAECC"
  },
  {
    title: "Fill Your Chair",
    subtitle: "Clients actively searching right now",
    image: barberImage,
    color: "#3BBFE5"
  },
  {
    title: "Take Beauty Appointments",
    subtitle: "Manage all bookings in one app",
    image: appointmentImage,
    color: "#4DD0FF"
  }
];

const SLIDE_COUNT = SLIDES.length;

const Carousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  // Use ref to track if component is mounted to prevent state updates after unmount
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    
    const interval = setInterval(() => {
      if (isMountedRef.current) {
        setCurrentSlide((prev) => (prev + 1) % SLIDE_COUNT);
      }
    }, 5000);
    
    return () => {
      isMountedRef.current = false;
      clearInterval(interval);
    };
  }, []); // Empty dependency array - SLIDE_COUNT is a constant

  return (
    <div className="auth-carousel">
      {SLIDES.map((slide, index) => (
        <div
          key={index}
          className={`auth-carousel-slide ${index === currentSlide ? 'active' : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="auth-carousel-overlay">
            <div className="auth-carousel-content">
              <h2>{slide.title}</h2>
              <p>{slide.subtitle}</p>
            </div>
          </div>
        </div>
      ))}
      
      <div className="auth-carousel-indicators">
        {SLIDES.map((_, index) => (
          <button
            key={index}
            className={`auth-carousel-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;